import { Component, OnInit } from '@angular/core';
import { UserService, ContextService, CartService } from '../../shared';
import { Router, RoutesRecognized, NavigationEnd } from '@angular/router';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/pairwise';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-log-in',
  templateUrl: './log-in.component.html',
  styleUrls: ['./log-in.component.scss']
})
export class LogInComponent implements OnInit {

  context: string;
  previousUrl:string;
  compteLogin:FormGroup;
  compteCrea:FormGroup;

  id:string;
  pw:string;
  isWrong:boolean = false;
  isWrongSite: boolean = false;
  auth_error: string = '';

  profils_pro:Array<any> = [
    {id:202, libelle:'Enseignant acheteur'},
    {id:203, libelle:'Agent comptable'},
    {id:204, libelle:'Acheteur collectivité'}
  ];
  profil:number;

  constructor(
  	private userService: UserService,
  	private formBuilder: FormBuilder,
    private contextService: ContextService,
     private cartService: CartService,
  	private router: Router,
  ) { 

    this.context = this.contextService.getContext();

  	this.compteLogin = formBuilder.group({
  		login: ['', Validators.compose([Validators.required])],
  		mdp: ['', Validators.compose([Validators.required, Validators.minLength(6), Validators.pattern('^[a-zA-z0-9]+$')])]
  	});

  	if(this.context == 'B2B'){
	  	this.compteCrea = formBuilder.group({
	  		profil: [null, Validators.compose([Validators.required])]
	  	});
  	} else {
  		this.compteCrea = formBuilder.group({
  			profil: [null]
  		})
  	}

  }

  ngOnInit() {
  }

  onSubmitLog(){
    this.isWrong = false;
  	if(!this.compteLogin.valid){
  		return;
  	}

  	let credentials = {
      login: this.id,
      password: this.pw
    };

    this.userService.attemptAuth('', credentials)
      .subscribe(data => {
        if(data == 'wrong_site'){
          this.isWrongSite = true;
        } else {
          this.isWrongSite = false;

          if(this.context == 'B2B') this.router.navigate(['/mon-panier']);
          if(this.context == 'B2C') this.router.navigate(['/familles/mon-panier']);
        }
    }, error => {
     
      this.auth_error = error[0].Message;
    	this.isWrong = true;
    });
  }

  redirected(){
    this.isWrongSite = false;
    this.cartService.destroyLocalCart();
  }

  onSubmitSign(){
 
  	if(!this.compteCrea.valid){
  		return;
  	}

  	if(this.context == 'B2B'){
  		this.router.navigate(['/creer-compte/']);
  	} else {
  		this.router.navigate(['/familles/creer-compte']);
  	}
  }

}



// WEBPACK FOOTER //
// ./src/app/user/_log-in/log-in.component.ts